import {PinIcon, PinSlashIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'

import {LABELS} from '../../constants/labels'
import {VALUES} from '../../constants/values'
import type {SavedView} from './types'

export interface PinControls {
  togglePin: (view: SavedView) => void
  pinnedCount?: number
  pinLimitLoading?: boolean
}

export function PinViewMenuItem({view, pinControls}: {view: SavedView; pinControls?: PinControls}) {
  if (!pinControls) return null

  const {togglePin, pinnedCount, pinLimitLoading} = pinControls
  const limitReached = !view.pinned && pinnedCount !== undefined && pinnedCount >= VALUES.maxPinnedViews
  const awaitingCount = !view.pinned && pinnedCount === undefined && pinLimitLoading

  return (
    <ActionList.Item
      loading={awaitingCount}
      inactiveText={limitReached ? LABELS.views.pinLimitReached(VALUES.maxPinnedViews) : undefined}
      onSelect={() => togglePin(view)}
    >
      <ActionList.LeadingVisual>{view.pinned ? <PinSlashIcon /> : <PinIcon />}</ActionList.LeadingVisual>
      <span>{view.pinned ? LABELS.views.unpin : LABELS.views.pin}</span>
    </ActionList.Item>
  )
}
